import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import LiveApp from "@/LiveApp";
import { DiagnosticBoundary } from "@/components/DiagnosticRecovery";
import { installDiagnostics } from "@/lib/diagnostics";

installDiagnostics();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <DiagnosticBoundary>
      {process.env.REACT_APP_LIVE_STANDALONE === "true" ? <LiveApp /> : <App />}
    </DiagnosticBoundary>
  </React.StrictMode>,
);
